import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { TextField } from "@/shared/components/Form/TextField";
import type {
  PlatformBlockComponent,
  PlatformBlockProps,
} from "../../../types";
import { BlockFormHeader } from "../BlockFormHeader";

export const Html: PlatformBlockComponent = ({ name }: PlatformBlockProps) => {
  const { t } = useTranslation();

  return (
    <Paper sx={{ p: 2 }}>
      <BlockFormHeader blockType="HTML" />
      <Grid container spacing={2}>
        <Grid size={12}>
          <TextField
            name={`${name}.code`}
            label={t("platformBlocks.html.code")}
            type="text"
            required
            multiline
            rows={6}
            fullWidth
          />
        </Grid>
        {/* <Grid size={3}>
          <TextField
            name={`${name}.paddingTop`}
            label={t("platformBlocks.fields.paddingTop")}
            type="number"
            fullWidth
          />
        </Grid>
        <Grid size={3}>
          <TextField
            name={`${name}.paddingBottom`}
            label={t("platformBlocks.fields.paddingBottom")}
            type="number"
            fullWidth
          />
        </Grid>
        <Grid size={3}>
          <TextField
            name={`${name}.maxWidth`}
            label={t("platformBlocks.fields.maxWidth")}
            type="number"
            fullWidth
          />
        </Grid>
        <Grid size={3}>
          <ColorPickerField
            name={`${name}.backgroundColor`}
            label={t("platformBlocks.fields.backgroundColor")}
            fullWidth
          />
        </Grid> */}
      </Grid>
    </Paper>
  );
};
